import React, { FormEvent, FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

import { hasAssemblyPermission } from '@paragon/login-tools';

import { getContextTotals } from '../../../../store/selectors/getContextTotals';
import { useAppSelector } from '../../../hooks';
import { ComponentListFilterControl } from './ComponentListFilterControl';
import ComponentSearchField from './ComponentSearchField';
import { ComponentSortControl } from './ComponentSortControl';

interface Props {
  searchingDisabled?: boolean;

  searchMessage: string;
  searchValue: string;

  onSearchChange: (value: string) => void;
}

export const PanelControlBar: FunctionComponent<Props> = (props) => {
  const canSort = useAppSelector(hasAssemblyPermission);
  const contextTotals = useAppSelector(getContextTotals);

  const searchActive = props.searchValue.trim().length !== 0;

  return (
    <Box
      component="form"
      sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginX: 1 }}
      autoComplete="off"
      onSubmit={(event: FormEvent) => event.preventDefault()}
    >
      {canSort && <ComponentSortControl />}

      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
        <Typography variant="body1" color="textPrimary" sx={{ flexGrow: 1 }}>
          {contextTotals && (
            <>
              {contextTotals.unique} Component Designs
              {contextTotals.total !== null && (
                <Box component="span" sx={{ color: 'text.secondary' }}>
                  {' '}
                  (total: {contextTotals.total})
                </Box>
              )}
            </>
          )}
        </Typography>

        <ComponentListFilterControl />
      </Box>

      <ComponentSearchField
        sx={{ marginBottom: 1 }}
        active={searchActive}
        disabled={props.searchingDisabled}
        message={props.searchMessage}
        value={props.searchValue}
        onChange={props.onSearchChange}
      />
    </Box>
  );
};
